module.exports = __webpack_public_path__ + "static/img/MD.51cba846.png";